import { t } from 'i18next';

export type PasswordRulesProps = {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
};

export function PasswordRulesList({
  hasMinLength,
  hasUppercase,
  hasLowercase,
  hasNumber,
  hasSpecialChar,
}: PasswordRulesProps) {
  const rules = [
    { value: hasMinLength, label: t('At least 8 characters') },
    { value: hasUppercase, label: t('At least one uppercase letter') },
    { value: hasLowercase, label: t('At least one lowercase letter') },
    { value: hasNumber, label: t('At least one number') },
    { value: hasSpecialChar, label: t('At least one special character') },
  ];

  return (
    <ul className="space-y-1 text-sm">
      {rules.map((rule, i) => (
        <li key={i} className={rule.value ? 'text-primary-700' : 'text-gray-500'}>
          {rule.value ? '✔' : '✖'} {rule.label}
        </li>
      ))}
    </ul>
  );
}
